import actions from "./actions";

const initState = {
  listCategory: [],
  isLoading: false,
  currentCategory: {},
};

export default function categoryReducer(state = initState, action) {
  switch (action.type) {
    case actions.SET_LIST_CATEGORY:
      return {
        ...state,
        listCategory: action.payload,
        isLoading: false,
      };
    case actions.SET_IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case actions.SET_CURRENT_CATEGORY:
      return {
        ...state,
        currentCategory: action.payload,
      };
    default:
      return state;
  }
}
